export default __webpack_public_path__ + "static/media/trash-white.3cf3befa.svg";